import { Controller } from "@hotwired/stimulus";
import { CsrfToken } from "../shared/csrf_token";
import { TurboStreamHeaders } from "../shared/turbo_stream_headers";

// Connects to data-controller="resumin--skill-sheet-mailer"
export default class extends Controller {
  static values = {
    skillSheetId: Number,
  };

  connect() {
    CsrfToken(this);
    TurboStreamHeaders(this);
  }

  submit(e) {
    e.preventDefault();

    const formData = new FormData();
    formData.append("id", this.skillSheetIdValue);

    fetch("/skill_sheet_mailer", {
      method: "POST",
      body: formData,
      headers: {
        ...this.csrfToken(),
        ...this.turboStreamHeaders(),
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.text();
      })
      .then((html) => {
        Turbo.renderStreamMessage(html);
      })
      .catch((error) => {
        console.error("Fetch error:", error);
      });
  }
}
